import React, { useCallback, memo } from "react";
import { withRedux, WithReduxHocPropsType } from "@al/next/al-ex";

import linkTo from "~/common/utils/linkTo";
import { tracker } from "~/common/tracker";

import { getTrackerSaReportInfo } from "../../../sensor-config";

import openApp from "./images/open_app.gif";
import styles from "./index.scss";

interface Props extends WithReduxHocPropsType {
  openAppLink: string;
}

const OpenAppBtn = (props: Props): JSX.Element => {
  const onClick = useCallback(async (): Promise<void> => {
    tracker.click({
      sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickOpenAPPBar" }),
    });
    props?.openAppLink && linkTo(props.openAppLink);
  }, [props?.openAppLink]);

  return <img src={openApp} className={styles.wrap} onClick={onClick} />;
};

export default withRedux((state) => ({
  openAppLink: state.static.openAppLink,
}))(memo(OpenAppBtn));
